(function() {
  const STORAGE_KEY = 'wb_overlay_questionnaire_answers';
  const STORAGE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  const CONTACT_PAGE_URL = window.CONTACT_PAGE_URL || '/pages/kontakt';
  const CART_BUTTONS_SELECTOR = '.product-form__buttons button, product-form .quick-add__submit, .cart__checkout-button, #checkout';

  function getCartButtons() {
    return document.querySelectorAll(CART_BUTTONS_SELECTOR);
  }

  function saveAnswers(answer, zip) {
    const payload = {
      answer: answer,
      zip: zip || null,
      timestamp: Date.now()
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch(exception) {
      console.error('Error saving answers to localStorage:', exception);
    }
  }

  function readAnswers() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if(!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if(typeof parsed !== 'object' || parsed === null) {
        return null;
      }
      if(typeof parsed.timestamp !== 'number' || typeof parsed.answer !== 'string' || !parsed.answer) {
        return null;
      }
      const age = Date.now() - parsed.timestamp;
      if(age > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      // Re-check against the current list, a stored result may stem from an older list
      parsed.zipValid = window.validateZipcode(parsed.zip);
      return parsed;
    } catch(exception) {
      console.warn('Error reading answers from localStorage:', exception);
      return null;
    }
  }

  function isProtectedPage() {
    const protectedUrls = [/\/pages\/kontakt/, /^\/policies/];
    const currentUrl = window.location.pathname;
    return protectedUrls.some(function(regex) {
      return regex.test(currentUrl);
    });
  }

  function shouldShowOverlayOnPageLoad() {
    if(isProtectedPage()) {
      return false;
    }
    const answers = readAnswers();
    return !answers;
  }

  function customerIsSuitable() {
    const answers = readAnswers();
    return answers && answers.answer === 'yes' && answers.zipValid;
  }

  function showOverlay(overlay) {
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
  }

  function closeOverlay(overlay, cartButtons) {
    overlay.setAttribute('hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    const answers = readAnswers();
    if(!answers || !answers.zipValid) {
      saveAnswers('skipped');
      disableButtons(cartButtons);
    } else {
      enableButtons(cartButtons);
    }
  }

  function disableButtons(buttons) {
    buttons.forEach(function(button) {
      button.classList.add('is-disabled');
    });
  }

  function enableButtons(buttons) {
    buttons.forEach(function(button) {
      button.classList.remove('is-disabled');
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const overlay = document.getElementById('wb-overlay-questionnaire');
    if(!overlay) {
      return;
    }
    const btnYes = overlay.querySelector('#wb-btn-yes');
    const btnNo = overlay.querySelector('#wb-btn-no');
    const zipStep = overlay.querySelector('#wb-overlay-step2');
    const zipInput = overlay.querySelector('#wb-zip-input');
    const zipSubmit = overlay.querySelector('#wb-zip-submit');
    const zipError = overlay.querySelector('#wb-zip-error');
    const closeBtn = overlay.querySelector('#wb-overlay-questionnaire-close');
    const zipContactCta = overlay.querySelector('#wb-zip-contact-cta');
    const zipForm = overlay.querySelector('#wb-zip-form');

    const answers = readAnswers();
    if(shouldShowOverlayOnPageLoad()) {
      showOverlay(overlay);
    } else if(!answers || !answers.zipValid) {
      disableButtons(getCartButtons());
    }

    // Delegated, so buttons added later are covered too, e.g. in the quick add popup
    document.addEventListener('click', function(event) {
      if(event.target.closest(CART_BUTTONS_SELECTOR) && !customerIsSuitable()) {
        event.preventDefault();
        showOverlay(overlay);
      }
    }, true);

    document.addEventListener('product-info:loaded', function() {
      if(!customerIsSuitable()) {
        disableButtons(getCartButtons());
      }
    });

    btnYes.addEventListener('click', function() {
      saveAnswers('yes');
      overlay.querySelector('#wb-overlay-step1').style.display = 'none';
      zipStep.style.display = '';
    });

    btnNo.addEventListener('click', function() {
      saveAnswers('no');
      window.location.href = CONTACT_PAGE_URL;
    });

    zipForm.addEventListener('submit', function(event) {
      event.preventDefault();
      if(!zipForm.checkValidity()) {
        zipInput.reportValidity();
        return;
      }
      handleZipSubmit();
    });

    function handleZipSubmit() {
      const zip = zipInput.value.trim();
      if(!zip) {
        return;
      }
      const stepTwoDescription = document.getElementById('wb-overlay-step2-description');
      if(stepTwoDescription) {
        stepTwoDescription.style.display = 'none';
      }
      const valid = window.validateZipcode(zip);
      saveAnswers('yes', zip);
      if(valid) {
        zipError.style.display = 'none';
        if(zipContactCta) {
          zipContactCta.style.display = 'none';
        }
        zipInput.style.display = 'none';
        zipSubmit.style.display = 'none';
        document.getElementById('wb-zip-success').style.display = '';
        const closeSuccessBtn = document.getElementById('wb-close-btn');
        if(closeSuccessBtn) {
          closeSuccessBtn.addEventListener('click', function() {
            closeOverlay(overlay, getCartButtons());
          });
        }
        overlay.addEventListener('mousedown', function(event) {
          if(event.target === overlay) {
            closeOverlay(overlay, getCartButtons());
          }
        });
      } else {
        zipError.style.display = '';
        if(zipContactCta) {
          zipContactCta.style.display = '';
        }
      }
    }

    if(closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeOverlay(overlay, getCartButtons());
      });
    }
  });
})();
